/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { getBodyStyle, getColor, type Theme } from 'styles/theme';

export const Wrapper = styled.a<{ theme: Theme }>`
    display: flex;
    gap: var(--Spacings-Spacing-4, 4px);
    height: 24px;
    padding: var(--Spacings-Spacing-4, 4px) var(--Spacings-Spacing-8, 8px);
    border-radius: var(--Spacings-Spacing-40, 40px);
    background: ${getColor('brandPrimary')};
    text-decoration: none;
`;

export const Title = styled.div<{ theme: Theme }>`
    ${getBodyStyle('graphikCond', { default: 'xsmall' }, 'medium')};
    color: ${getColor('textLink')};
    font-weight: 500;
    line-height: 120%;
`;
